import { Pipe, PipeTransform } from '@angular/core';
import { RelationshipStatus } from '../../../models/enum/shared/relationship-status';
import { RelationshipStatusUtils } from '../../../utils/relationship-status-utils';

@Pipe({
  name: 'relationshipStatusFileUploadLabel'
})
export class RelationshipStatusFileUploadLabelPipe implements PipeTransform {
  transform(value: RelationshipStatus): string {
    return RelationshipStatusUtils.getRelationshipFileUploadLabel(value);
  }
}
